import { IconButton, Snackbar } from "@mui/joy";
import Box from "@mui/joy/Box";
import Button from "@mui/joy/Button";
import Checkbox from "@mui/joy/Checkbox";
import Divider from "@mui/joy/Divider";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";

import Stack from "@mui/joy/Stack";
import Typography from "@mui/joy/Typography";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { Timestamp } from "firebase/firestore";
import * as React from "react";
import { Link, useNavigate } from "react-router";
import { auth } from "../../config/firebase";
import { addUsers, sendMessage } from "../../config/services";
import { Visibility, VisibilityOff } from "@mui/icons-material";

export default function SignUp() {
  const navigate = useNavigate();

  const [loading, setLoading] = React.useState(false);
  const [values, setValues] = React.useState({
    numberformat: "",
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmpassword: "",
    showPassword: false,
    country: "United States", // set up with reactlocalstorage
    mobilecode: "+1",
  });

  const [open, setOpen] = React.useState({
    open: false,
    message: "",
  });

  const handleChange = (event) => {
    setValues({ ...values, [event.target.name]: event.target.value });
  };

  const handleClose = () => {
    setOpen({ ...open, open: false });
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const submitForm = (event) => {
    event.preventDefault();
    setLoading(true);
    const datas = {
      ...values,
      btc_balance: 0,
      bnb_balance: 0,
      tron_balance: 0,
      eth_balance: 0,
      usdt_balance: 0,
      usdterc20_balance: 0,
      timestamp: Timestamp.now(),
    };

    createUserWithEmailAndPassword(auth, datas.email, datas.password)
      .then((user) => {
        console.log("user created");
        const userid = user.user.uid;
        addUsers(userid, datas).then(() => {
          setOpen({
            ...open,
            open: true,
            message: "Sign up successful redirecting to login...",
          });

          sendMessage(
            `<strong>Welcome to Starmart wallet, Your registration was successful, and your account is activated, thank you.`,
            "Account Registration",
            datas.email,
            `${values.firstName} ${values.lastName}`
          )
            .then(() => {
              setTimeout(() => {
                setLoading(false);
                navigate("/");
              }, 7000);
            })
            .catch(() => {
              setTimeout(() => {
                setLoading(false);
                navigate("/");
              }, 7000);
            });
        });
      })
      .catch((error) => {
        const errorMessage = error.message;
        setOpen({
          ...open,
          open: true,
          message: errorMessage,
        });
        console.log(errorMessage);
        setLoading(false);
      });
  };

  return (
    <Box
      component="main"
      sx={{
        my: 5,
        py: 2,
        pb: 5,
        display: "flex",
        flexDirection: "column",
        gap: 2,
        width: 400,
        maxWidth: "100%",
        mx: "auto",
        borderRadius: "sm",
        "& form": {
          display: "flex",
          flexDirection: "column",
          gap: 2,
        },
        [`& .MuiFormLabel-asterisk`]: {
          visibility: "hidden",
        },
      }}
    >
      <Stack sx={{ gap: 1 }}>
        <Typography component="h1" level="h3">
          Create wallet
        </Typography>
        <Typography level="body-sm">
          Existing wallet?{" "}
          <Link
            to={"/auth/login"}
            style={{ textDecoration: "none", color: "#0c6bcc" }}
          >
            Sign in
          </Link>
        </Typography>
      </Stack>

      <Divider
        sx={(theme) => ({
          [theme.getColorSchemeSelector("light")]: {
            color: { xs: "#FFF", md: "text.tertiary" },
          },
        })}
      ></Divider>
      <Stack sx={{ gap: 4, mt: 2 }}>
        <form onSubmit={submitForm}>
          <FormControl size="lg" required>
            <FormLabel>Email</FormLabel>
            <Input onChange={handleChange} type="email" name="email" required />
          </FormControl>
          <FormControl size="lg" required>
            <FormLabel>Password</FormLabel>
            <Input
              sx={{ "--Input-decoratorChildHeight": "45px" }}
              type={values.showPassword ? "text" : "password"}
              onChange={handleChange}
              name="password"
              required
              endDecorator={
                <IconButton
                  variant="plain"
                  color="neutral"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                >
                  {values.showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              }
            />
          </FormControl>
          <Stack sx={{ gap: 4, mt: 2 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Checkbox
                size="sm"
                label="I agreeI agree to terms."
                name="persistent"
              />
            </Box>
            <Button loading={loading} type="submit" fullWidth>
              Create new
            </Button>
          </Stack>
        </form>
      </Stack>
      <Snackbar
        color="success"
        size="md"
        variant="soft"
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={open.open}
        onClose={handleClose}
      >
        {open.message}
      </Snackbar>
    </Box>
  );
}
